import { Controller } from "@hotwired/stimulus";
import _ from "lodash";
import { Chart } from "chart.js";

export default class extends Controller {
  static values = {
    showValues: Boolean,
  };

  interval = null;

  count = 0;

  connect() {
    this.interval = setInterval(() => {
      const charts = document.getElementsByClassName("chart");
      if (charts.length > 0) {
        if (
          _.every(charts, (container) => {
            return container.chart.isCreated();
          })
        ) {
          clearInterval(this.interval);
          this.toggleValues();

          setTimeout(() => window.print(), 1000);
        }
      } else {
        clearInterval(this.interval);
      }
    }, 250);
  }

  toggleValues = () => {
    console.log(this.showValuesValue);
    if (this.showValuesValue == true) return;

    const canvases = document.querySelectorAll("canvas");
    canvases.forEach((canvas, index) => {
      const chart = Chart.getChart(canvas.id);

      chart.data.datasets.forEach((label) => {
        label.datalabels = {
          ...label.datalabels,
          display: false,
        };
      });

      chart.update();
    });
  };
}
